/* eslint-disable no-param-reassign */
const genderTypes: {id: number, name: string}[] = [
  { id: 1, name: "Homem" },
  { id: 2, name: "Mulher" },
  { id: 3, name: "Homem Trans" },
  { id: 4, name: "Mulher Trans" },
  { id: 5, name: "Não Binário" },
  { id: 6, name: "Outro" },
  { id: 7, name: "Helicóptero de Combat" }
];

function getGenderNameById(id: number): {id: number, name: string} {
  let ret = genderTypes.find(genderTypes => genderTypes.id === id);
  if (!ret) ret = { id: -1, name: "Undefined" };
  return ret;
}

export { genderTypes, getGenderNameById };

